// extracted by mini-css-extract-plugin
export default {"container":"login_container__5K63n","content":"login_content__hkVgi"};